import React from 'react';
import { useIntl, defineMessages } from 'react-intl';
import LinkButtonMenu from './LinkButtonMenu';

const messages = defineMessages({
  button: {
    id: 'Link stile Bottone',
    defaultMessage: 'Link stile bottone',
  },
});

const LinkButton = (props) => {
  const intl = useIntl();
  return (
    <LinkButtonMenu {...props} title={intl.formatMessage(messages.button)} />
  );
};

export default function install(config) {
  const { slate } = config.settings;

  slate.buttons.linkButton = LinkButton; //override di volto-rt-slate LinkButton to add dropdown

  return config;
}
